import { Link } from "react-router-dom";
import alojamiento from "../../../assets/img/alojamiento.png";

const CargaAlquiler = () => {

  return (
    <div className="mx-auto md:w-[80%] w-full bg-white rounded-lg shadow-sm border">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 py-5 px-5">
        <div>
          <span className="text-primary font-bold text-xl">Administrá tu anuncio</span>
          <span className="block font-bold my-3">Cargar tu alojamiento / excursión es muy fácil</span>

          <div className="mb-5">
            <span className="font-bold">1 Contanos acerca de tu alojamiento</span>
            <span className="block">Compartí algunos datos básicos, como la ubicación y cuantos huespedes pueden quedarse en el lugar.</span>
            <hr />
          </div>

          <div className="mb-5">
            <span className="font-bold">2 Hacé que se destaque</span>
            <span className="block">Agregá al menos 5 fotos más el título y la descripción. Nosotros te ayudamos.</span>
            <hr />
          </div>

          <div className="mb-5">
            <span className="font-bold">3 Terminá todo y publicá el anuncio</span>
            <span className="block">Elegí si preferis empezar con un huésped que ya lleve un tiempo usando la plataforma, establecé un precio inicial y publicá tu anuncio.</span>
          </div>

          <Link to={'/alquiler/carga/pasos'} style={{ borderRadius: "10px" }} className="cursor-pointer flex rounded-full btn w-full btn-filled-2">
            Comenzar
            <button className="hidden"></button>
          </Link>
        </div>
        <div className="flex justify-center w-full">
          <img src={alojamiento} alt="" className="w-[250px] h-auto object-cover" />
        </div>
      </div>
    </div>
  )
}

export default CargaAlquiler